export default function StatCard({ icon, bgColor, textColor, label, value, newValue }) {
  return (
    <div className="bg-white rounded-xl p-4 sm:p-6 shadow-sm border border-[#F0F0F0]">
      <div className="flex items-center justify-center gap-4">
        <div className={`w-10 h-10 sm:w-12 sm:h-12 ${bgColor} rounded-lg flex items-center justify-center`}>
          <img src={icon} alt="icon" className={`w-5 h-5 sm:w-6 sm:h-6 ${textColor}`} />
        </div>
        <div>
          <p className="text-xs sm:text-sm text-gray mb-1">{label}</p>
          <div className="flex items-baseline gap-2 flex-wrap">
            <span className="text-xl sm:text-2xl font-bold text-dark-blue">{value}</span>
            <div className="flex px-2 py-1 sm:px-3 sm:py-2 justify-center items-center gap-2 rounded-full border border-purple/10 bg-purple/10">
              <span className="text-xs sm:text-sm text-purple font-medium">{newValue} New</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}